module.exports = __webpack_public_path__ + "3310f595ec962a3adbd2f529789cd404.png";